// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-rate .rc-rate-star {
  margin-right: 30px;
  /* Adjust to control the space between stars */
}`, "",{"version":3,"sources":["webpack://./../jobportal/src/components/PortalSelfAssessment/RatingSystem/RatingSystem.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EAAoB,8CAAA;AAExB","sourcesContent":[".custom-rate .rc-rate-star {\n    margin-right: 30px; /* Adjust to control the space between stars */\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
